/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {NavLink} from "react-router-dom";


import {Col} from "react-bootstrap";


type FormFieldInfoLinkComponentProps = {
    linkLabel?: string;
    linkURL: string;
    linkText: string;
};


export const FormFieldInfoLinkComponent: React.FC<FormFieldInfoLinkComponentProps> = ({
    linkLabel = "", linkURL, linkText
}): JSX.Element | null => {


    if (!linkURL || !linkText) return null;


    return (
        <Col xs={12} className={"user-form-field-info-link"}>
            <NavLink to={linkURL} title={linkLabel}>
                <span>{linkText}</span>
            </NavLink>
        </Col>
    );

};


export default FormFieldInfoLinkComponent;
